import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import * as uuid from 'uuid';


import { ConfirmOrder } from './../../models/confirm-order.model';
import { ConfirmBillTo } from './../../models/confirm-bill-to.model';
import { ConfirmShipTo } from './../../models/confirm-ship-to.model';
import { ConfirmOrderDetails } from './../../models/confirm-order-details.model';
import { CartItem } from './../../models/cart-item.model';

import { ShoppingCartService } from './../../services/site/shopping-cart.service';
@Injectable({
  providedIn: 'root'
})
export class SessionOrderService {

  sessionOrder: ConfirmOrder;
  processing = false;

  constructor(
    private readonly shoppingCartService: ShoppingCartService
  ) { }

  // Amounts are deliberately left at zero. The API prices the order (POST
  // /api/User/orders/totals) and is the only thing allowed to produce money values;
  // this used to compute its own subtotal and tax, which could - and did - disagree.
  public getSessionOrder(orderId: number): ConfirmOrder {
    console.log('getSessionOrder');

    this.sessionOrder = this.initializeConfirmOrder(orderId);


    // this.sessionOrder.orderTotal = this.sessionOrder.subTotal + this.sessionOrder.shippingTotal + this.sessionOrder.salesTax;

    return this.sessionOrder;

 }

  private initializeConfirmOrder(orderId: number) {
    console.log('initializeConfirmOrder');
    return new ConfirmOrder({
      billTo: this.getSessionShipTo(),
      shipTo: this.getSessionShipTo(),
      orderDetails: this.getSessionOrderDetails(orderId),
      lineItems: this.getSessionLineItems(),
      subTotal: 0,
      salesTax: 0,
      shippingTotal: 0,
      orderTotal: 0,
      userId: 0,
      accountId: 0,
      identifier: uuid.v4()
    });
  }

  private getSessionBillTo() {
    console.log('getSessionBillTo');
    let data = JSON.parse(sessionStorage.getItem('billTo'));
    if (data === null || data === undefined) {
      data = new ConfirmBillTo();
    }
    return new ConfirmBillTo({
      companyName: data.companyName,
      firstName: data.firstName,
      lastName: data.lastName,
      address1: data.address1,
      aptNumber: data.aptNumber,
      address2: data.address2,
      fullAddress: this.getSessionAddressLine(data.address1, data.aptNumber, data.address2),
      city: data.city,
      stateCode: data.stateCode,
      postalCode: data.postalCode,
      countryCode: data.countryCode,
      emailAddress: data.emailAddress,
      phoneNumber: data.phoneNumber
    });
  }

  private getSessionAddressLine(address1: string, aptNumber: string, address2: string) {
    let address1Str = address1;
    if (aptNumber.trim().length > 0) {
      address1Str = address1Str + ' #' + aptNumber;
    }
    if (address2.trim().length > 0) {
      address1Str = address1Str + ' ' + address2;
    }
    return address1Str;
  }

  private getSessionShipTo() {
    console.log('getSessionShipTo');
    let data = JSON.parse(sessionStorage.getItem('shipTo'));
    if (data === null || data === undefined) {
      data = new ConfirmShipTo();
    }
    return new ConfirmShipTo({
      companyName: data.companyName,
      courseNumber: data.courseNumber,
      instructorName: data.instructorName,
      firstName: data.firstName,
      lastName: data.lastName,
      address1: data.address1,
      aptNumber: data.aptNumber,
      address2: data.address2,
      fullAddress: this.getSessionAddressLine(data.address1, data.aptNumber, data.address2),
      city: data.city,
      stateCode: data.stateCode,
      postalCode: data.postalCode,
      countryCode: data.countryCode,
      emailAddress: data.emailAddress,
      phoneNumber: data.phoneNumber
    });
  }

  private getSessionOrderDetails(orderId: number) {
    console.log('getSessionOrderDetails');
    return new ConfirmOrderDetails({
      orderId,
      orderDate: new Date(),
      destinationType: 'Residential',
      shippingCarrier: 'USPS - Priority Mail'
    });
  }

  private getSessionLineItems() {
    console.log('getSessionLineItems');
    return this.shoppingCartService.getItems();
  }


}
